module.exports = __webpack_public_path__ + "static/media/1efa_edit.4bad5dbc.pdb";


//////////////////
// WEBPACK FOOTER
// ./src/data/1efa_edit.pdb
// module id = 187
// module chunks = 0